// extracted by mini-css-extract-plugin
export default {"stepCounter":"MyProfileQuestions_stepCounter__XlGjU"};